import { ProductCatalogEmbroideryPlacement } from '../../../__generated__/graphql/catalog/graphql'

export const getEmbroideryPlacementKey = (
  placement: Pick<ProductCatalogEmbroideryPlacement, 'location' | 'position'>
) => `${placement.location}:${placement.position}`
